const theme = require('./theme.json');
module.exports = theme;